import { render, staticRenderFns } from "./BarSTD.vue?vue&type=template&id=898a4df6&scoped=true&"
import script from "./BarSTD.vue?vue&type=script&lang=ts&"
export * from "./BarSTD.vue?vue&type=script&lang=ts&"
import style0 from "./BarSTD.vue?vue&type=style&index=0&id=898a4df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898a4df6",
  null
  
)

export default component.exports